<template>
    <!-- 对话框 -->
    <el-drawer title="生成二维码" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="600px">
        <!-- 基本信息表单 -->
        <div class="form-box">
            <template>
                <el-form ref="form" :model="submit_data" label-width="80px" style="height: 90vh; overflow-y: auto">
                    <el-form-item label="绑定三方" label-width="120px">
                        <el-select style="width:200px" v-model="submit_data.third_id" placeholder="请选择三方" @visible-change="sfVisibleChange" clearable>
                            <el-option v-for="item in third" :key="item.third_id" :label="item.third_name" :value="item.third_id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="生成数量（张）" label-width="120px">
                        <el-input v-model="submit_data.num" placeholder="生成数量" style="width: 200px; margin-right: 5px"> </el-input>
                    </el-form-item>

                    <el-form-item label="权益类型" label-width="120px">
                        <el-select style="width:200px" v-model="submit_data.equity_type" clearable>
                            <el-option label="免起步价" value="1"></el-option>
                            <el-option label="减免金额" value="2"></el-option>
                        </el-select>
                        <el-input
                            v-if="submit_data.equity_type == 2"
                            v-model="submit_data.equity_amount"
                            style="width: 150px; margin-left: 10px"
                        ></el-input
                        ><span style="margin-left: 10px" v-if="submit_data.equity_type == 2">元</span>
                    </el-form-item>
                </el-form>
                <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                    <el-button type="primary" @click="onSubmitDig">保存</el-button>
                    <el-button @click="closeDialog">关闭</el-button>
                </div>
            </template>
        </div>
    </el-drawer>
</template>

<script>
var _this;
export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
        }
    },
    data() {
        return {
            show: false,

            third: [],

            // 表单数据
            submit_data: {
                num: '',
                third_id: '',
                equity_amount: '0',
                equity_type: ''
            },

            submit_rules: {
                third_id: {
                    placeholder: '绑定三方',
                    rules: {
                        required: true,
                        message: '绑定三方为小于50的正整数',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                num: {
                    placeholder: '生成数量',
                    rules: {
                        required: true,
                        message: '生成数量为小于50的正整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                },
                equity_type: {
                    placeholder: '权益类型',
                    rules: {
                        required: true,
                        message: '权益类型为小于50的正整数',
                        regulation: 'gt_str',
                        rulesData: 0
                    }
                },
                equity_amount: {
                    placeholder: '减免金额',
                    rules: {
                        required: false,
                        message: '减免金额为大于0的整数',
                        regulation: 'int',
                        rulesData: 0
                    }
                }
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        sfChange(val) {
            _this.submit_data.third_id = val;
        },
        sfVisibleChange(val) {
            if (val) {
                _this
                    .$post('/Cooperatewine/thirdAccountList')
                    .then((res) => {
                        _this.third = res.data;
                    })
                    .catch((err) => {});
            }
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.submit_rules.equity_amount.rules.required = false;
            _this.submit_rules.equity_amount.rules.rulesData = '0';
            _this.submit_data = {
                num: '',
                third_id: '',
                equity_amount: '0',
                equity_type: ''
            };
        },

        onSubmitDig() {
            if (_this.submit_data.equity_type == '2') {
                _this.submit_rules.equity_amount.rules.required = true;

                _this.submit_rules.equity_amount.rules.rulesData = '1';
            } else {
                _this.submit_rules.equity_amount.rules.required = false;
                _this.submit_rules.equity_amount.rules.rulesData = '0';
                _this.submit_data.equity_amount = '0';// 选择减免金额且减免金额数量为8，然后再切换成免起步价，应把金额清空
           
            }
            _this
                .$post('/Cooperatewine/addCooperateWine', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success(res.msg);

                    _this.closeDialog();

                    _this.$emit('onSubmit');
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}
.item-wrap {
    margin-bottom: 10px;
}
</style>
